/*jslint browser */
/*global process */

import Configurator from "../model/configurator/configurator";

var $ = jQuery;

/**
 *
 */
export default class ConfiguratorController
{
    private _configurator: Configurator;
    private _settings: any;
    private _accessoryBox: JQuery;
    private _configuratorItem: JQuery;
    private _generatePdf: JQuery;

    constructor(settings: any)
    {
        this._settings = settings;
        this._configurator = new Configurator();
    }

    public configuratorAction(): void
    {
        this.registerEvents();
        this._configurator.init();
        this._configurator.setMainProductId(this._settings.productId);
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._accessoryBox = $('.accessory-box');
        this._configuratorItem = $('.configurator-item');
        this._generatePdf = $('.generate-pdf');
        $('[data-toggle="tooltip"]').tooltip();

        this._accessoryBox.on('click', (e) => {
            this.accessoryBoxClick($(e.currentTarget));
        })

        this._configuratorItem.on('click', (e) => {
            this.configuratorItemClick($(e.currentTarget));
        })

        this._generatePdf.on('click', (e) => {
            this.eneratePdfClick();
        })
    }

    private accessoryBoxClick(ob: JQuery): void {
        this.changeAccessoryChecboxStatus(ob);
    }

    private changeAccessoryChecboxStatus(ob: JQuery): void {
        this._configurator.changeAccessoryChecboxStatus(ob);
    }

    private configuratorItemClick(ob: JQuery): void {
        this.refreshConfigurator(ob);
    }

    private refreshConfigurator(ob: JQuery): void {
        this._configurator.changeItem(ob);
    }

    private eneratePdfClick(): void {
        this._configurator.generatePdf();
    }
}